module.exports = __webpack_public_path__ + "img/cc-icon.40ca844c.png";